export const GET_COURSE_LIVE_LIST='GET_COURSE_LIVE_LIST';
export const GET_COURSE_VOD_LIST='GET_COURSE_VOD_LIST';
// export const GET_COURSE_VOD_AND_LIVE_LIST='GET_COURSE_VOD_AND_LIST';
// export const GET_KEY_WORD='GET_KEY_WORD';
export const GET_LESSON_LIVE_LIST='GET_LESSON_LIVE_LIST';
export const GET_LESSON_VOD_LIST='GET_LESSON_VOD_LIST';
export const IS_NEW_SEARCH='IS_NEW_SEARCH';


// WEBPACK FOOTER //
// ./src/redux/type/search.type.js